import { useQuery } from "@tanstack/react-query"

import { api } from "@/api"
import { ENDPOINTS } from "@/constants"

const getCustomerById = async (
  customerId: string
): Promise<Customer> => {
  const url = ENDPOINTS.CUSTOMER_BY_ID.replace(
    "{{customerId}}",
    customerId
  )
  const { data } = await api.get<Customer>(url)
  return data
}

export const useCustomerById = (customerId: string) => {
  return useQuery({
    queryKey: [ENDPOINTS.CUSTOMER_BY_ID, customerId],
    queryFn: () => getCustomerById(customerId),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    enabled: !!customerId,
  })
}

export default useCustomerById
